/**
 * @generated SignedSource<<28fd699bfd3b94647e55fce68a5de49f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelectedCustomerRegisterFormFields_charge$data = {
  readonly customerRegisterFields: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly id: string;
  readonly paymentMethodSelected: string | null | undefined;
  readonly " $fragmentType": "PaymentMethodSelectedCustomerRegisterFormFields_charge";
};
export type PaymentMethodSelectedCustomerRegisterFormFields_charge$key = {
  readonly " $data"?: PaymentMethodSelectedCustomerRegisterFormFields_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelectedCustomerRegisterFormFields_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelectedCustomerRegisterFormFields_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodSelected",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerRegisterFields",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "48ec276957933074fd3accd72ea2720b";

export default node;
